import { atom } from "recoil";

export const trackGetAllCheckListStateChange = atom({
    key: 'trackGetAllCheckListStateChangeKey', // unique ID (with respect to other atoms/selectors)
    default: '', // default value (aka initial value)
  });
  